import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {

  api = '/api/admin';

  constructor(private http: HttpClient) {}

  getComments(): Observable<any> {
    return this.http.get(`${this.api}/comments`);
  }

  approve(id: number) {
    return this.http.post(`${this.api}/comments/${id}/approve`, {});
  }

  reject(id: number) {
    return this.http.post(`${this.api}/comments/${id}/reject`, {});
  }

  delete(id: number) {
    return this.http.delete(`${this.api}/comments/${id}`);
  }

}